import { SHOW_ERROR, HIDE_ERROR } from "../actions/types";
const INITIAL_STATE = { showError: false, validationError: false }

const errorReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SHOW_ERROR:
            return { ...state, showError: true, validationError: null, errorMessage: action.payload.detail, validationErrorMessage: action.payload };
        case HIDE_ERROR:
            return { ...state, showError: false };
        default:
            return state;
    }
};

export default errorReducer